import React from 'react'

import { AnalyticsPaymentMethodLabel } from '../../../../analyticsModule/components/AnalyticsPaymentMethod/AnalyticsPaymentMethodLabel'
import type { AnalyticsPaymentMethodLabelType } from '../../../../analyticsModule/components/AnalyticsPaymentMethod/AnalyticsPaymentMethodLabel.types'
import { useAnalyticsCardBase } from '../../../../hooks/useAnalyticsCardBase'
import type { BarStatsReportCardProps } from '../../AnalyticsDashboard.types'
import { createStatsData } from '../../utils/createStatsData'

const reportId = 'payment_method_used'

type PaymentMethodUsedRow = {
  payment_method: string
  percentage: number
}

export const usePaymentMethodUsedReportCard = (): BarStatsReportCardProps => {
  const analyticsCardBase = useAnalyticsCardBase({
    reportId,
  })

  const data = createStatsData<PaymentMethodUsedRow>({
    rows: analyticsCardBase.reportData?.report?.rows,
    mapFn: (row) => ({
      label: (
        <AnalyticsPaymentMethodLabel type={row.payment_method as AnalyticsPaymentMethodLabelType} />
      ),
      value: row.percentage,
    }),
  })

  return {
    ...analyticsCardBase,
    type: 'barStats',
    data,
    header: {
      ...analyticsCardBase.header,
      label: 'Payment method used',
      tooltip: {
        title: 'Payment method used',
        description: 'Breakdown of sales grouped by payment method.',
      },
    },
  }
}
